import InternalOrderManagemnt from "./table"

function InternalOrderManagement() {
  return (
    <>
      <InternalOrderManagemnt />
    </>
  )
}

export default InternalOrderManagement
